export default {
  rice: "برنج",
  fruit: "میوه",
  water: "آب",
  bread: "نان",
  vegetable: "سبزیجات",
  chicken: "مرغ",
  dairy: "لبنیات",
  egg: "تخم‌مرغ",
  legume: "حبوبات",
  others: "سایر",
  description: "توضیحات",
};
